import { constValuePair, nameValuePair } from '../../models/common.model';

export const encryptionKeys = {
  IV: '',
  key: ''
};

export const SignUpType = {
  Email: 1,
  Phone: 2
};

export const INVOICE_TYPE = {
  COURSE: 1,
  PACKAGE: 2,
  SESSION: 3,
  OTHERS: 4
};

export const LOCATION_TYPE = {
  NO_ADDRESS: 1,
  STUDENTS_ADDRESS: 2,
  SPECIFY_ADDRESS: 3,
  VIRTUAL_MEETING: 4
};

export const PAYROLL_RATE_TYPE = {
  HOURLY: 1,
  MONTHLY: 2
};

export const TRANSACTION_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  FAILED: 3,
  CANCELLED: 4
};

export const VISIBILITY = {
  SELF : 1,
  STUDENT: 2,
  PARENT: 3
};

export const ProcessType = {
  Forget: 1,
  Verify: 2,
  SignUp: 3,
  Login: 4,
  Profile: 5
};

export const fileFolder = {
  File: 1,
  Folder: 2
};

export const columnValueType = {
  Nothing: 0,
  SlideToggle: 1,
  Action: 2,
  Object: 3,
  Select: 4,
  Button: 5
};

export const InitialScreenTab = {
  STUDENTORPARENT: 1,
  TUTORORCOUNSLER: 2
};

export const UserRole = {
  ADMIN: 1,
  STUDENT: 2,
  TUTOR: 3,
  COUNSELOR: 4,
  PARENT: 5,
  SUBADMIN: 6
};

export const Gender = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3
};

export const EMPLOYMENT_TYPE = {
  SELF_EMPLYED: 1,
  INSTITUTION: 2,
  COACHING_CENTER: 3
};

export const ACADEMIC_TYPE = {
  SCHOOL: 1,
  UNIVERSITY: 2
};

export const TUTOR_MODE = {
  VIRTUAL: 1,
  IN_PERSON: 2,
  BOTH: 3
};

export const StudentParentRelation = {
  FATHER: 1,
  MOTHER: 2,
  OTHER: 3
};

export const BufferTime: Array<nameValuePair> = [
  {
    value: '1',
    name: '1minute'
  },
  {
    value: '2',
    name: '2minutes'
  },
  {
    value: '3',
    name: '3minutes'
  },
  {
    value: '4',
    name: '4minutes'
  },
  {
    value: '5',
    name: '5minutes'
  },
  {
    value: '6',
    name: '6minutes'
  },
  {
    value: '7',
    name: '7minutes'
  },
  {
    value: '8',
    name: '8minutes'
  },
  {
    value: '9',
    name: '9minutes'
  },
  {
    value: '10',
    name: '10minutes'
  },
  {
    value: '11',
    name: '11minutes'
  },
  {
    value: '12',
    name: '12minutes'
  }
];

export const Modes: Array<nameValuePair> = [
  {
    value: '1',
    name: 'Virtual'
  },
  {
    value: '2',
    name: 'Physical'
  },
  {
    value: '3',
    name: 'Both'
  }
];


export const DaysData: Array<nameValuePair> = [
  {
    name: 'Monday',
    value: '1'
  },
  {
    name: 'Tuesday',
    value: '2'
  },
  {
    name: 'Wednesday',
    value: '3'
  },
  {
    name: 'Thursday',
    value: '4'
  },
  {
    name: 'Friday',
    value: '5'
  },
  {
    name: 'Saturday',
    value: '6'
  },
  {
    name: 'Sunday',
    value: '7'
  }
];


export const statusKey : Array<nameValuePair> = [
 
  // {
  //   name:'Ongoing',
  //   value: '2'

  // },
  {
    name:'Pending',
    value: '0'
  },
  {
    name:'Upcoming',
    value: '1'

  },
  {
    name:'Completed',
    value: '3'

  },
  {
    name:'Cancelled',
    value: '4'
  }
];

export const PACKAGE_SERVICE_TYPE_ARRAY : Array<nameValuePair> = [
  {
    name:'Tutoring Session',
    value:'1'
  },
  {
    name:'Counseling Session',
    value:'2'
  }

];

export const WORKFLOW_ACCESSIBILITY = {
  ANYTIME: 1,
  ONCE_PER_MONTH: 2,
  TWICE_PER_MONTH: 3
};

export const INVOICETYPE = {
  COURSE: 1,
  PACKAGE: 2,
  SESSION: 3,
  OTHERS: 4
};

export const privacyConst : Array<constValuePair> = [
  {
    name:'Private',
    value:1
  },
  {
    name:'Public',
    value:2
  }

];

export enum SNS_TYPE {
  GOOGLE = 1,
  APPLE = 2,
  FB = 3,
}

export const TodoType = {
  Self: 1,
  Student: 2
};

export const PACKAGE_SERVICE_TYPE = {
  TUTORING: 1,
  COUNSELLING: 2
};

export const PACKAGE_SERVICE_FILTER_TYPE = {
  TUTORING: 3,
  COUNSELLING: 4
};

export const SESSION_TYPE = {
  TUTORING: 1,
  COUNSELING: 2
};

export const PACKAGE_TYPE = {
  ONE_TIME: 1,
  RECURRING: 2
};

export const PACKAGE_VISIBILITY = {
  NEW: 1,
  EXTENT_CURRENT: 2
};

export const PROMO_TYPE = {
  FIXED: 1,
  PERCENTAGE: 2
};

export const ConsultationType = {
  Paid: 1,
  Free: 2
};

export const SESSION_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  ONGOING: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  RESCHEDULED: 5
};

export const  VIEW_ABILITY_CONST = {
  Students: 1,
  Instructors: 2,
  Both: 3
};

export const StudentAddEdit = {
  Add: 1,
  Edit: 2
};

export const TasksStatus = {
  PENDING: 1,
  COMPLETED: 2
};

export const SessionType = {
  Single: 1,
  Multi: 2
};

export const ATTENDANCETYPE = {
  PRESENT: 1,
  ABSENT: 2,
  LATE: 3,
  CANCELLD: 4,
  CANCELLED_WITH_NOTICE: 5,
  CANCELLED_WITH_EXCEPTION: 5,
  CANCELLED_WITH_TUTOR: 5
};

export const ATTENDANCE_TYPE = [
  {
    name: 'Present',
    value: ATTENDANCETYPE.PRESENT
  },
  {
    name: 'Absent',
    value: ATTENDANCETYPE.ABSENT
  },
  {
    name: 'Late',
    value: ATTENDANCETYPE.LATE
  },
  {
    name: 'Cancelled',
    value: ATTENDANCETYPE.CANCELLD
  }
];
export const sessionModeConst = [
  {
    value: '1',
    name: 'Online'
  },
  {
    value: '2',
    name: 'Offline'
  }
];

export const  SESSION_LOCATION_TYPE = {
  NO_ADDRESS: 1,
  STUDENTS_ADDRESS: 2,
  SPECIFY_ADDRESS: 3,
  VIRTUAL_MEETING: 4
};

export const SESSION_CATEGORY_COLORS: { [key: number]: string } = {
  1: '#2E568E',  // BLUE
  2: '#344242',  // GREEN
  3: '#D43C00',  // ORANGE
  4: '#C6003B',  // PINK
  5: '#604274',  // PURPLE
  6: '#BE0219',  // RED
  7: '#743A00',  // YELLOW
  8: '$c_black',  // BLACK
  9: '#4F2700',  // BROWN
  10: '#AA3000', // DARK_ORANGE
  11: '#004A34', // GRASS_GREEN
  12: '#434444', // GREY
  13: '#604274', // LAVENDER
  14: '#424E5B', // LIGHT_GREY
  15: '#9B0027', // LIGHT_PINK
  16: '#004A34', // LIME
  17: '#B92E71', // MAGENTA
  18: '#005C5C', // MINT
  19: '#313216', // OLIVE
  20: '#0C3369', // ROYAL
  21: '#940237', // RUBY
  22: '#C33700', // SALMON
  23: '#006F8F', // SEA_BLUE
  24: '#4F2700', // TAN
  25: '#E34C00', // TANGERINE
  26: '#005C5C', // TEAL
  27: '$c_white'  // WHITE
};

export const iconConstNew:Array<any> = [
  {
    key: 'videoCameraAlt1',
    value: 1,
    iconLink: '../../../assets/icons/video-camera-alt.png'
  },
  {
    key: 'skype',
    value: 2,
    iconLink: '../../../assets/icons/skype.png'
  },
  {
    key: 'marker',
    value: 3,
    iconLink: '../../../assets/icons/marker.png'
  },
  {
    key: 'house-chimney',
    value: 4,
    iconLink: '../../../assets/icons/house-chimney.png'
  },
  {
    key: 'graduation-cap',
    value: 5,
    iconLink: '../../../assets/icons/graduation-cap.png'
  },
  {
    key: 'car',
    value: 6,
    iconLink: '../../../assets/icons/car.png'
  },
  {
    key: 'building',
    value: 7,
    iconLink: '../../../assets/icons/building.png'
  },
  {
    key: 'bank',
    value: 8,
    iconLink: '../../../assets/icons/bank.png'
  }
];

export const SESSION_CATEGORY_ICONS: { [key: number]: string } = {
  1: '../../../assets/icons/video-camera-alt.png',
  2: '../../../assets/icons/skype.png',
  3: '../../../assets/icons/marker.png',
  4: '../../../assets/icons/house-chimney.png',
  5: '../../../assets/icons/graduation-cap.png',
  6: '../../../assets/icons/car.png',
  7: '../../../assets/icons/building.png',
  8: '../../../assets/icons/bank.png'
};

export const PRIORITY_LEVEL = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

export const TodoStatus = {
  Pending: 1,
  Completed: 2
};

export const UserStatus = {
  STUDENT: 1,
  SELF: 2
};

export const SortBy = {
  Newest: 1,
  Oldest: 2
};

export const ActionPlanStatus = {
  Pending: 1,
  Completed: 2
};
export const CollegeFields = {
  TEXT :'text',
  INPUT :'input',
  NUMBER: 'number',
  TEXTAREA:'textarea',
  DROPDOWN:'dropdown',
  MULTISELECT:'multiselect',
  RADIO:'radio',
  CHECKBOX: 'checkbox',
  DATE: 'date'
};

export const SatScore = [
  {
    min: 1,
    max:1000,
    value: 1
  },
  {
    min: 1001,
    max:1200,
    value: 2
  },
  {
    min: 1201,
    max:1400,
    value: 3
  },
  {
    min: 1401,
    max: 1600,
    value: 4
  },
  {
    min: 1600,
    max:10000000000000000000,
    value: 5
  }
];

export const Fees = [
  {
    min: 1,
    max:5000,
    value: 1
  },
  {
    min: 5001,
    max:10000,
    value: 2
  },
  {
    min: 10001,
    max:20000,
    value: 3
  },
  {
    min: 20001,
    max: 40000,
    value: 4
  },
  {
    min: 40001,
    max:10000000000000000000,
    value: 5
  }
];

export const RESOURCE_CATEGORY = {
  FILE:1,
  COURSE:2,
  ARTICLE:3
};

export const CourseMaterialType = {
  LessonVideo: 1,
  Quiz: 2
};

export const CREATEDBY = {
  NEWUSER: 0,
  ADMIN: 1,
  STUDENT: 2,
  TUTOR: 3,
  COUNSELOR: 4,
  PARENT: 5,
  SUBADMIN: 6,
  SUPERADMIN: 7,
  SUPER_SUBADMIN: 8,
  INSTRUCTOR: 9
};

export const ticketTypeConst = [
  {
    value: '1',
    name: 'General Ticket'
  },
  {
    value: '2',
    name: 'Project Related Ticket'
  }
];

export const priorityConst = [
  {
    value: '1',
    name: 'Low'
  },
  {
    value: '2',
    name: 'Medium'
  },
  {
    value: '3',
    name: 'High'
  }
];

export const RecipientConst = [
  {
    value: '1',
    name: 'Notify Coordinator'
  },
  {
    value: '2',
    name: 'Notify Admin Only'
  }
];
export const ticketFilterOne = {
  ACTIVE: 1,
  RESOLVED: 2
};

export const ticketFilterTwo = {
  NEWEST: 1,
  OLDEST: 2
};

export const chatType = {
  Personal:0,
  Group:1
};

export const MESSAGE_TYPE = {
  TEXT: 1,
  IMAGE: 2,
  VIDEO: 3,
  LOCATION: 4,
  DOCUMENT:5,
  VOICE:6
};

export const TRANSACTION_TYPE = {
  CHARGES: 1,
  PAYMENT: 2,
  DISCOUNT: 3,
  REFUND: 4
};

export const notesVisibilityMap = {  
  self : 1,
  student : 2,
  parent : 5
};

export interface keyValuePair {
  key: string;
  value: number;
}


export const notesVisibilityArray: Array<keyValuePair> = [
  {
    key: 'Self',
    value: 1
  },
  {
    key: 'Student',
    value: 2
  },
  {
    key: 'Parent',
    value: 5
  },
  {
    key: 'Both',
    value: 6
  }
];

export const ACTIVITY_MODULES = {
  PROFILE: 1,
  SESSION: 2,
  ACTION_PLAN: 3,
  USER: 4,
  COURSE: 5,
  PACKAGE: 6
};

export const ACTIVITY_TYPES = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
  VIEW: 4,
  ACCEPT: 5,
  REJECT: 6,
  LOGIN: 7,
  LOGOUT: 8,
  CHANGE_PW: 9,
  RESET_PW: 10,
  OTHERS: 11
};
